import React from 'react';
import { DatePicker } from 'antd';
import { monthFormat } from '../../constant/constant_format';

const { RangePicker } = DatePicker;


const RangeMonth = ({ ...props }) => {
    return (
        <RangePicker 
        {...props}
        style={props.style ? props.style : { width: '100%' }}
        format={monthFormat} 
        picker="month" 
        />
    );
};
export default RangeMonth;
